import { styled } from '@mui/material/styles'

export interface StatusTagProps {
  absolute: boolean | undefined
  position: 'bottom' | 'top'
  size: 'small' | 'medium' | 'large'
}
export const StatusTag = styled('div')<{ color: string } & StatusTagProps>(
  ({ theme, color, absolute, position, size }) => ({
    color: theme.palette.getContrastText(color),
    backgroundColor: color,
    borderRadius: '0.5rem',
    padding: size === 'small' ? '0.2rem 0.4rem' : '0.5rem',
    position: absolute ? 'absolute' : undefined,
    [position]: absolute ? '1rem' : undefined,
    right: absolute ? '1rem' : undefined,
    width: 'fit-content',
    fontWeight: size === 'small' ? 600 : 700,
    fontSize: size === 'small' ? '0.9rem' : '1rem',
    textTransform: 'uppercase',
    textAlign: 'center',
  })
)
